import { Link, useLocation } from 'react-router-dom';

export function SignInSent() {
  const { state } = useLocation() as { state?: { email?: string } };
  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '1.5rem',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: '420px' }}>
        <h1 style={{ fontSize: '1.4rem', fontWeight: 500, letterSpacing: '-0.01em' }}>
          Check your email
        </h1>
        <p
          style={{
            color: 'var(--muted-foreground, #6b6b6b)',
            fontSize: '0.95rem',
            marginTop: '0.5rem',
          }}
        >
          {state?.email
            ? `We sent a sign-in link to ${state.email}.`
            : 'We sent you a sign-in link.'}{' '}
          It expires shortly.
        </p>
        <p style={{ marginTop: '1.5rem', fontSize: '0.875rem' }}>
          <Link to="/sign-in" style={{ color: '#004AAD' }}>
            Use a different email
          </Link>
        </p>
      </div>
    </main>
  );
}
